export default __webpack_public_path__ + "static/media/proof-of-payment.21dddb5f.png";